import React from 'react'
import MainTitle from '../../../components/ui/MainTitle'
import VariantsForm from '../../../components/store/products/form/VariantsForm'
import { useVariantCategories } from '../../../hooks/store/variantCategories'

export default function AddProductVariant() {
  const {data:categories} = useVariantCategories();
  return (
    <div className='container p-6 h-[100vh] overflow-auto'>
        <div className="mb-14">
            <MainTitle title="add_new_product"/>
        </div>
        <div>
            <VariantsForm categoriesList={categories?categories.map(ca=>({id:ca.id,name:ca.languages[0].name})):[]}/>
        </div>
    </div>
  )
}
